import React, { Component } from "react";
import "../../css/toastView.css";
 
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
 
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
import "../../components/new.css";
 
import "react-tabs/style/react-tabs.css";
import "../../css/events.css";
 
import "../../components/slick.css";
import "../../components/slick-theme.css";
 

 
const icon1 = "https://winpeforum.com/assets/elements/AishwaryaJaishankar.jpg";
const icon2 = "https://winpeleadershipsummit.winpeforum.com/wp-content/uploads/2026/03/Untitled-design-1.png";
const icon3 = "https://winpeforum.com/assets/elements/SunithaViswanathan.jpg";
const icon5 = "https://winpeforum.com/assets/elements/SaloniJhaveri.png";
const icon6 = "https://winpeforum.com/assets/elements/ShivaniBhasin.png";
const icon4 = "https://winpeforum.com/assets/elements/bhavna.png";
const icon12 = "https://winpeforum.com/assets/elements/HardikaShah.jpg";

let duration = 400;





const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

class WinPEEdge extends Component {
  // constructor() {
  //   super();
  //   this.state = {
  //     isShow: false,
  //     activeItem: {},
  //   };
  // }

  // togglePopUp = (item) => {
  //   this.setState({
  //     isShow: !this.state.isShow,
  //     activeItem: item || {},
  //   });
  // };
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };

    this.Speaker1 = [
      {
          imgUrl: icon2,
          desc: `<div>
        Anjali Sosale is a GP at WaterBridge Ventures where she focuses on consumption and the gig economy. She was previous with Myntra Jabong and EY in leadership roles and is based in Bangalore. WaterBridge is a VC firm that partners with founders early, with a $1-3M cheque and continues to invest until Series C. 
          
          </div>`,
          name: "AnjaIi Sosale",
          post: `<div>Partner<br/> WaterBridge Ventures
  
  
          </div>`,
        },
         {
            imgUrl: icon12,
            desc: `As the solo founder of fintech Kinara Capital, Hardika is recognized social entrepreneur and a dedicated advocate of Financial Inclusion. With the pioneering use of AI and tech-enabled solutions, Kinara Capital advanced the lives of over 1 lakh small business owners across 100+ cities in India that in turn impacted over half a million lives in local economies with new job creation and income generation. <br/><br/>

As a purpose-driven entrepreneur, Hardika has been recognized for her leadership in building inclusive finance solutions and for championing gender equality in the workplace.  <br/><br/>
Her accolades include being named among the Forbes India W-Power List of Top 20 Self-Made Women, receiving the Economic Times Startup Award, the United Nations award for Leadership, and national recognition by the Government of India as one of the Top 75 Women Entrepreneurs Transforming India.  <br/><br/>
Hardika has also been invited as a TEDx speaker, and her unique story has been featured by The Better India, Humans of Bombay, Mint newspaper, Entrepreneur magazine and more.  <br/><br/>

Before founding Kinara Capital, Hardika spent nearly two decades in Management Consulting working across the US, Europe, and Asia-Pacific, and mentoring social entrepreneurs through leading global institutions. <br/><br/>s

Hardika holds a Bachelor’s degree in Computer Science from Knox College and an MBA from the joint program of Columbia Business School and UC Berkeley Haas School of Business.
`,
            name: "Hardika Shah",
            post: `<div>Founder & CEO <br/>Kinara Capital</div>`,
            
          }, 
       
 
      
   {
        imgUrl: icon4,
        desc: `<div>
      Bhavna Suresh is an entrepreneur renowned for attracting top-tier talent and architecting margin-centric, scalable strategies across the Asia-Pacific region. A lifelong learner, she thrives in collaborative environments alongside diverse experts and is dedicated to refining the art of deep listening.<br/><br/>

In 2020, she achieved a successful exit from a multi-million-dollar PropTech venture, a milestone reached alongside her exceptional team.<br/><br/>

Bhavna is deeply committed to cross-cultural collaboration, with a steadfast focus on driving inclusion and championing women’s representation in the workforce.<br/><br/>

She is the founder of Stylebank and holds an MBA from HEC Paris, as well as an Engineering degree from VTU Bangalore.

        
        
        </div>`,
        name: "Bhavna Suresh        ",
        post: `<div>Co-Founder<br/>
        10club<br/>(Moderator)
        
  
  
        </div>`,
      },
 
      
    ];

    this.Speaker2 = [
       
      
      {
        imgUrl: icon2,
        desc: `Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.
<br/><br/>
At McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.


         `,
        name: "Alka Goel",
        post: `<div>Founding Partner<br/> Alkemi Growth Capital
        </div>`,
      },

      
    ];
    
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };

  

  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
     
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;

    return (
      <ContentPage>
      <Meta
      title="sheshines with Winpe"
      image={"https://winpeforum.com/assets/elements/sheshineswebpage1.png"}
      description="Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions!"
      location={location}
    />
      <div className="section__content" style={defaultStyle}>
     <div className="toastshine_wrapper">
     
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div> 
   
            <div className="toastshine_section">
        <h1 className="ignite-ask-me-anything__heading">sheshines with Winpe </h1>
        
           
        <hr className="ignite-ask-me-anything__hr"></hr>
        <div className="top_text">
       sheshines is a women’s empowerment initiative focused on enabling learning, professional growth, and greater participation of women across professional and governance ecosystems.<br/><br/>

The initiative creates inclusive opportunities through learning-led engagements, knowledge-sharing platforms, collaborations, and partnerships that support women’s advancement, visibility, and participation across sectors.
<br/><br/>

              </div>
              <br />

              <br />
             

    
      
   
  <div className="tab_section container" style={{textAlign: 'center'}}>
   
  <ul class="nav nav-tabs justify-content-center" role="tablist" style={{display: "inline-block"}}>
  <li class="nav-item">
		<a class="nav-link  " data-toggle="tab" href="#tabs-3" role="tab" style={{padding: "10px 5px"}}>
      <h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp; Mumbai&nbsp;  </h4> </a>
	</li>
	<li class="nav-item">
		<a class="nav-link   " data-toggle="tab" href="#tabs-1" role="tab" style={{padding: "10px 5px"}}> <h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp;  Delhi&nbsp;   </h4> </a>
	</li>
  <li class="nav-item">
		<a class="nav-link  active " data-toggle="tab" href="#tabs-2" role="tab" style={{padding: "10px 5px"}}> 
    <h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp;  Bangalore&nbsp;   </h4> </a>
	</li>
	
 
</ul> 
<div class="tab-content">
	<div class="tab-pane " id="tabs-1" role="tabpanel"><br/><br/> 
  
  <div className="eventlist_listing eventlist_listing_new">
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>February 17, 2026 (5:00 PM - 8:00 PM IST)</h3>
                      
                  <h4> <i>Jaypee Vasant Continental, New Delhi
                  </i></h4>
                 <br/> 
                 <center>  
                 <a href="/sheshines17Feb2026/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
        
              
                          </div>
                      </div>
                    </div>  <hr/><hr/>
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>September 24, 2025 (5:00 PM - 8:00 PM IST)</h3>
                      
                  <h4> <i>Google office, Gurgaon
                  </i></h4>
                  <br/>
                            <strong>
                            AI as the New Co-Founder You Didn’t Know You Needed
                            </strong>
                            
          
              <br/>
                 <br/> 
                 <center>  
                 <a href="/sheshines24Sep2025/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
         
                          </div>
                      </div>
                    </div> 
                    
                   
                     <hr/><hr/>



  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>February 6, 2025 (5:00 PM - 8:00 PM IST)</h3>
                      
                  <h4> <i>Jaypee Vasant Continental, Vasant Vihar, New Delhi
                  </i></h4>
                 <br/> 
                 <center>  
                 <a href="/sheshines6Feb2025/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
        
              
                          </div>
                      </div>
                    </div>  <hr/><hr/>
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>August 7, 2024 (5:00 PM - 8:00 PM IST)</h3>
                  <br/>
                            <strong>
                            Navigating the Investor - Founder relationship

                            </strong>
                  
                  <h4> <i>Delhi NCR</i></h4>
                             
                  <center>  
                  <a href="/SheShines7Aug2024/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
                        
                       
                          <hr/><hr/>
              
                          </div>
                      </div>
                    </div>
    
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>January 24, 2024 (5:00 PM - 8:00 PM IST)</h3>
                  <br/>
                            <strong>
                            Networking works  

                            </strong>
                  
                  <h4> <i>Delhi NCR</i></h4>
                             
                  <br/> <br/>               

          <center>  
         <a href="/SheShines24Jan2024/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
                         
             
                      

                          <hr/><hr/>
              
                          </div>
                      </div>
                    </div>
    
  
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>July 27, 2023 (5:00 PM - 8:00 PM IST)</h3>
                  
                  <br/>
                            <strong>
                           Journeys: Women & Leadership 

                            </strong>
                            <h4> <i>JW Marriott, Aerocity, New Delhi</i></h4>
                           <br/> <br/>
                                   

<center>  
<a href="/sheshines27July2023/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
         
             
                      


              
                          </div>
                      </div>
                    </div>
       
              <hr/><hr/>       
 
             
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>August 25, 2022 (5:00 PM - 8:00 PM IST)</h3>
                  <br/>
                            <strong>
                            Networking works  

                            </strong>
                  
                  <h4> <i>Hotel Andaz, Aerocity - Delhi</i></h4>
                             
                  <br/> <br/>               

          <center>  
         <a href="/SheShines25Aug2022/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
     
                          <hr/><hr/>
                          <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>       
                          </div>
                      </div>
                    </div>
       
            
  
              </div>        
                    
	</div>
  <div class="tab-pane active" id="tabs-2" role="tabpanel"><br/><br/> 
  
  <div className="eventlist_listing eventlist_listing_new">
<div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>July 2, 2026 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                           <br/>
                            <strong style={{fontSize:'16px'}}>
                        The honest debrief - What we got wrong on both sides of the table
                            </strong>
                            <h4><i>Bangalore International Centre</i></h4>
                          
              <br /> 
                 <br/>
   <center>  
                 <a href="/sheshines2July2026/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center>
                     
                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>  


<div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>December 11, 2025 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                           <br/>
                            <strong style={{fontSize:'16px'}}>
                         From Idea to Impact: What Investors Look For — The said and the unsaid 
                            </strong>
                            <h4><i>Bangalore International Centre</i></h4>
                          
              <br /> 
                 <center>  
                  <a href="/sheshines11Dec2025/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
                        

                     
                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>  


  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>June 19, 2025 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                           <br/>
                            <strong style={{fontSize:'16px'}}>
                           The Founder-Investor Dance: Building High-Trust Relationships That Win

                            </strong>
                          
                            <h4> <i>  Bangalore
                            </i></h4>
                          
                         
            
              <br />  
                 <center>  
                  <a href="/sheshines19June2025/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
                        
         
              <center><h4>Hosted By:</h4> 
              <img src={"https://winpeforum.com/assets/elements/epicworld-removebg-preview.png"} style={{width:'100px'}}/>
              </center>
              <br/>
                     
                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>  
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>November 28, 2024 (4:00 - 7:00 PM IST)</h3>
                           <br/>
                            
                          
                            <h4> <i> Wink, Vivanta, Bengaluru
                            </i></h4>
                          
                         
            
              <br />  
              <center>  
                  <a href="/Sheshines28Nov2024/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
                        
                       
 
              <center><h4>In collaboration with:</h4> 
              <img src={"https://winpeforum.com/assets/elements/vivanta.png"} style={{width:'400px'}}/>
              </center>
              <br/><br/>
             
                 
        

           
                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>  
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>May 23, 2024 (5:00 - 8:00 PM IST)</h3>
                          
                            <h4>
                         <i>  Bangalore International Centre</i> 
                            </h4>
                           
<br/>
<center>  
         <a href="/SheShines23May2024/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 

<br/>
                 

                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>             
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>August 24, 2023 (5:00 PM - 8:00 PM IST)</h3>
                  
                         
                        <br/>
                        <h4> <i>Bangalore International Centre </i></h4>
                             

     
<br/>
  
<center>  
         <a href="/SheShines24Aug2023/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
     
                         
              
                          </div>
                      </div>
                    </div>
       
              <hr/><hr/>
               
            
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>January 19, 2023 (4:00 PM - 7:00 PM IST)</h3>
                  <br/>
                            <strong>
                             Journeys: Women & Leadership 

                            </strong>
                  
                  <h4> <i>Jook Taproom, Indiranagar, Bangalore</i></h4>
                            <br/><br/>
                            <center>  
         <a href="/SheShines19Jan2023/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 

  
              
                          </div>
                      </div>
                    </div>
       
              <hr/><hr/>

  
              </div> 



  <div className="eventlist_listing eventlist_listing_new">
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>June 30, 2022 (5:00 PM - 8:00 PM IST)</h3>
                  <br/>
                            <strong>
                            Networking Works: Leveraging Networks for Growth and Success 

                            </strong>
                  
                  <h4> <i>Kazé, Bangalore</i></h4>
                            <br/><br/>
                    
                          <center>  
         <a href="/SheShines30June2022/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
                 
              
                          </div>
                      </div>
                    </div>
       
              <hr/><hr/>

  
              </div>        
                    
	</div>
	<div class="tab-pane     " id="tabs-3" role="tabpanel"><br/><br/> 
 
  <div className="eventlist_listing eventlist_listing_new">
    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>November 6, 2025 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                            
                            <strong>
                       Up Close with A91 Partners: Building a differentiated investment firm
                            </strong>
                            <h4> <i> A91 Partners Office, Mumbai
                            </i></h4>
                         
            
              <br />  
              
                 <center><h4>Hosted By:</h4> <br/>
          <img src={"https://winpeforum.com/assets/elements/A91_Final.jpeg"} style={{width:'60px'}}/>  
</center>      <br/>  
   <center>  
              <a href="/sheshines06Nov2025/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center>
                        </div>
                      </div>
                    </div> 

  


                  
  <hr/><hr/>  
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>October 17, 2024 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                            
                          
                            <h4> <i> Motilal Oswal Tower, Prabhadevi, Mumbai
                            </i></h4>
                          
                          <h4>Hosted by: Motilal Oswal</h4>
            
              <br />  
              <center>  
              <a href="/SheShines17Oct2024/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> <br/>
 
                    

                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>  
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>October 13, 2023 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                            <strong>
                            The Role of Self
                            </strong>
                          
                            <h4> <i> A91 Partners, Mumbai </i></h4>
                            <br/> 
                          
            
              <br />  
          
<center>  
<a href="/sheshines13Oct2023/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
               

                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>            
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>November 10, 2022 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                            <strong>
                            Journey's: Women & Leadership
                            </strong>
                          
                            <h4> <i>The Quorum Club, LowerParel, Mumbai</i></h4>
                            <br/><br/>
                          <center>  
         <a href="/SheShines10Nov2022/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>April 21, 2022 (4:30 PM IST)</h3>
                           <br/>
                            <strong>
                            Networking works
                            </strong>
                          
                            <h4> <i>The Quorum Club, LowerParel, Mumbai</i></h4>
                            <br/><br/>
                          <center>  
         <a href="/SheShinesWithWinPE/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
              
                        </div>
                      </div>
                    </div>
                    <hr/><hr/>
                   
                    </div>
 
 
 
 
 </div>
	</div>
 
</div>
        
<br/>    <br/><br/>  <br/><br/>  <br/><br/>  <br/><br/>  <br/><br/>  <br/><br/>  <br/><br/>  <br/><br/>  <br/><br/>  <br />    <br />    <br />    <br />    <br />    <br />    <br />       <br />    <br />    <br />    <br />    <br />    <br />    <br />       <br />    <br />    <br />    <br />    <br />    <br />    <br />       <br />    <br />    <br />    <br />    <br />    <br />    <br />       
<br /><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/> <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>   <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/>        <br/> <br/> <br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/>       <br/> <br/>        <br/> <br/>        <br/> <br/>       
</div>
                <TeamModal
                show={isShow}
                onHide={this.togglePopUp}
                activeItem={this.state.activeItem}
              />
      </div></div>
      </ContentPage>
    );
  }
}




WinPEEdge.propTypes = {
  location: PropTypes.object,
};

export default WinPEEdge;
 


// WEBPACK FOOTER //
// ./src/pages/SheShines/index.js